module.exports = __webpack_public_path__ + "img/JRR.586194e.jpg";